export const subscriptionPlans = {
  homeschool: {
    titleId: 'pricing_plan.homeschool.title',
    trialTitleId: 'pricing_plan.homeschool.trial_title',
    seats: {
      students: 5,
      educators: 1,
    },
    licenses: ['SIMPLE_ONE_TIME_PAID_SUBSCRIPTION_HOMESCHOOL'],
    trialLicenses: ['SELF_SERVICE_TRIAL_HOMESCHOOL'],
    price: 50,
    percentOff: 0.5,
  },
  classroom: {
    titleId: 'pricing_plan.classroom.title',
    trialTitleId: 'pricing_plan.classroom.trial_title',
    seats: {
      students: 30,
      educators: 4,
    },
    licenses: ['SIMPLE_ONE_TIME_PAID_SUBSCRIPTION_CLASSROOM'],
    trialLicenses: ['SELF_SERVICE_TRIAL_CLASSROOM'],
    price: 150,
    percentOff: 0.5,
  },
  school: {
    titleId: 'pricing_plan.school.title',
    trialTitleId: 'pricing_plan.school.trial_title',
    seats: {
      students: 500,
      educators: 100,
    },
    licenses: [
      'SIMPLE_ONE_TIME_PAID_SUBSCRIPTION_SCHOOL',
      'SIMPLE_ONE_TIME_PAID_SUBSCRIPTION',
    ],
    trialLicenses: ['SELF_SERVICE_TRIAL_SCHOOL', 'SELF_SERVICE_TRIAL'],
    price: 900,
    percentOff: 0.5,
  },
};

export const pricingOptions = [
  {
    id: 'homeschool',
    price: subscriptionPlans.homeschool.price,
    term: 'year',
    percentOff: subscriptionPlans.homeschool.percentOff,
  },
  {
    id: 'classroom',
    price: subscriptionPlans.classroom.price,
    term: 'year',
    percentOff: subscriptionPlans.classroom.percentOff,
  },
  // {
  //   id: 'school',
  //   price: subscriptionPlans.school.price,
  //   term: 'year',
  //   percentOff: subscriptionPlans.school.percentOff,
  // },
  {
    id: 'custom',
    priceString: 'Custom pricing',
  },
];

export const getLicenseTermById = {
  SELF_SERVICE_TRIAL: 'trial',
  SELF_SERVICE_TRIAL_SCHOOL: 'trial',
  SELF_SERVICE_TRIAL_CLASSROOM: 'trial',
  SELF_SERVICE_TRIAL_HOMESCHOOL: 'trial',
  SIMPLE_ONE_TIME_PAID_SUBSCRIPTION: 'annual',
  SIMPLE_ONE_TIME_PAID_SUBSCRIPTION_SCHOOL: 'annual',
  SIMPLE_ONE_TIME_PAID_SUBSCRIPTION_HOMESCHOOL: 'annual',
  SIMPLE_ONE_TIME_PAID_SUBSCRIPTION_CLASSROOM: 'annual',
};

export const getLicenseType = {
  SELF_SERVICE_TRIAL: 'school',
  SELF_SERVICE_TRIAL_SCHOOL: 'school',
  SELF_SERVICE_TRIAL_HOMESCHOOL: 'homeschool',
  SELF_SERVICE_TRIAL_CLASSROOM: 'classroom',
  SIMPLE_ONE_TIME_PAID_SUBSCRIPTION: 'school',
  SIMPLE_ONE_TIME_PAID_SUBSCRIPTION_SCHOOL: 'school',
  SIMPLE_ONE_TIME_PAID_SUBSCRIPTION_HOMESCHOOL: 'homeschool',
  SIMPLE_ONE_TIME_PAID_SUBSCRIPTION_CLASSROOM: 'classroom',
};

export const normalizeLicenseType = (licenseType) => {
  switch (licenseType) {
    case 'SELF_SERVICE_TRIAL':
      return 'SELF_SERVICE_TRIAL_SCHOOL';
    case 'SIMPLE_ONE_TIME_PAID_SUBSCRIPTION':
      return 'SIMPLE_ONE_TIME_PAID_SUBSCRIPTION_SCHOOL';
    default:
      return licenseType;
  }
};

export const getAvailableUpgrade = {
  SELF_SERVICE_TRIAL: 'SIMPLE_ONE_TIME_PAID_SUBSCRIPTION_SCHOOL',
  SELF_SERVICE_TRIAL_SCHOOL: 'SIMPLE_ONE_TIME_PAID_SUBSCRIPTION_SCHOOL',
  SELF_SERVICE_TRIAL_HOMESCHOOL: 'SIMPLE_ONE_TIME_PAID_SUBSCRIPTION_HOMESCHOOL',
  SELF_SERVICE_TRIAL_CLASSROOM: 'SIMPLE_ONE_TIME_PAID_SUBSCRIPTION_CLASSROOM',
  SIMPLE_ONE_TIME_PAID_SUBSCRIPTION: null,
  SIMPLE_ONE_TIME_PAID_SUBSCRIPTION_SCHOOL: null,
  SIMPLE_ONE_TIME_PAID_SUBSCRIPTION_HOMESCHOOL: null,
  SIMPLE_ONE_TIME_PAID_SUBSCRIPTION_CLASSROOM: null,
};

export const getTrialLicenseByType = {
  school: 'SELF_SERVICE_TRIAL_SCHOOL',
  homeschool: 'SELF_SERVICE_TRIAL_HOMESCHOOL',
  classroom: 'SELF_SERVICE_TRIAL_CLASSROOM',
};

export const getPaidLicenseByType = {
  school: 'SIMPLE_ONE_TIME_PAID_SUBSCRIPTION_SCHOOL',
  homeschool: 'SIMPLE_ONE_TIME_PAID_SUBSCRIPTION_HOMESCHOOL',
  classroom: 'SIMPLE_ONE_TIME_PAID_SUBSCRIPTION_CLASSROOM',
};

export const getPlanByLicense = (licenseId) => {
  if (!Object.keys(getLicenseType).includes(licenseId)) return false;
  const type = getLicenseType[licenseId];
  const plan = subscriptionPlans[type];
  return {
    ...plan,
    licenseId,
    type,
    computedPrice: plan.percentOff ? plan.price * plan.percentOff : plan.price,
    licenseTerm: getLicenseTermById[licenseId],
    availableUpgrade: getAvailableUpgrade[licenseId],
  };
};
